import axios from 'axios'
import { userLogin, userRegister, userDetail ,userRecover } from '../../config/urlConstants'
export default {
  authUserAction (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post(userLogin, payload.user, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        if (response.data[0].status === 'success') {
          let data = response.data[1].messages
          context.commit('authUserCommit', data)
          localStorage.setItem('email', data.email)
          localStorage.setItem('lastlogin', data.email)
          localStorage.setItem('user', data.firstname)
          localStorage.setItem('lang', data.reglang)
          localStorage.setItem('secureid', data.secureid)
          localStorage.setItem('mid', data.id)
          resolve(true)
        } else {
          resolve(false)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  addUserAction (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post(userRegister, payload.user, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        if (response.data[0].status === 'success') {
          let data = response.data[1].messages
          context.commit('authUserCommit', data)
          localStorage.setItem('email', data.email)
          localStorage.setItem('user', data.firstname)
          localStorage.setItem('lang', data.reglang)
          localStorage.setItem('secureid', data.secureid)
          localStorage.setItem('mid', data.id)
          resolve(response)
        } else {
          resolve(response)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  userRecoverAction(context, payload){
    return new Promise((resolve, reject) => {
      axios.post(userRecover, payload.user, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        if (response.data[0].status === 'success') {
          let data = response.data[1].messages
          context.commit('authUserCommit', data)
          localStorage.setItem('email', data.email)
          resolve(response)
        } else {
          resolve(response)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getUserDetail (context, payload) {
    axios.post(userDetail, payload.user , {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(response => {
      if (response.data[0].status === 'success') {
        let data = response.data[1].messages
        context.commit('loginUserDetail', data)
      }
    }).catch(error => {
      console.log(error)
    })
  },
  setLangAction (context, payload) {
    context.commit('setLangCommit', payload)
  }
}
